const act = name => ({
  [name]: name,
  [name + '_SUCCESS']: name + '_SUCCESS',
  [name + '_FAILURE']: name + '_FAILURE'
});

export const {
  FETCH_DSAS,
  FETCH_DSAS_SUCCESS,
  FETCH_DSAS_FAILURE
} = act('FETCH_DSAS');

export const {
  CREATE_DSA,
  CREATE_DSA_SUCCESS,
  CREATE_DSA_FAILURE
} = act('CREATE_DSA');


export const {
  FETCH_DSA,
  FETCH_DSA_SUCCESS,
  FETCH_DSA_FAILURE
} = act('FETCH_DSA');

export const {
  STAR_DSA,
  STAR_DSA_SUCCESS,
  STAR_DSA_FAILURE
} = act('STAR_DSA');

export const {
  UNSTAR_DSA,
  UNSTAR_DSA_SUCCESS,
  UNSTAR_DSA_FAILURE
} = act('UNSTAR_DSA');

export const {
  CLONE_DSA,
  CLONE_DSA_SUCCESS,
  CLONE_DSA_FAILURE
} = act('CLONE_DSA');

export const {
  CONVERT_CUSTOMER_DSA,
  CONVERT_CUSTOMER_DSA_SUCCESS,
  CONVERT_CUSTOMER_DSA_FAILURE
} = act('CONVERT_CUSTOMER_DSA');

export const {
  CONVERT_DSA,
  CONVERT_DSA_SUCCESS,
  CONVERT_DSA_FAILURE
} = act('CONVERT_DSA');

export const {
  FETCH_DSA_CONFIG,
  FETCH_DSA_CONFIG_SUCCESS,
  FETCH_DSA_CONFIG_FAILURE
} = act('FETCH_DSA_CONFIG');

export const {
  TOGGLE_SECURITY_CORRELATIONS,
  TOGGLE_SECURITY_CORRELATIONS_SUCCESS,
  TOGGLE_SECURITY_CORRELATIONS_FAILURE
 } = act('TOGGLE_SECURITY_CORRELATIONS');

export const {
  FETCH_ACCOUNT,
  FETCH_ACCOUNT_SUCCESS,
  FETCH_ACCOUNT_FAILURE
} = act('FETCH_ACCOUNT');

export const {
  MARK_DSA_AS_PRESENTED,
  MARK_DSA_AS_PRESENTED_SUCCESS,
  MARK_DSA_AS_PRESENTED_FAILURE
} = act('MARK_DSA_AS_PRESENTED');

export const {
  MARK_DSA_AS_CLOSED,
  MARK_DSA_AS_CLOSED_SUCCESS,
  MARK_DSA_AS_CLOSED_FAILURE
} = act('MARK_DSA_AS_CLOSED');

export const {
  TOGGLE_BUSINESS_AREA,
  TOGGLE_BUSINESS_AREA_SUCCESS,
  TOGGLE_BUSINESS_AREA_FAILURE
} = act('TOGGLE_BUSINESS_AREA');

export const {
  UPDATE_DSA,
  UPDATE_DSA_SUCCESS,
  UPDATE_DSA_FAILURE
} = act('UPDATE_DSA');

export const {
  UPDATE_DSA_AREA_NOTE,
  UPDATE_DSA_AREA_NOTE_SUCCESS,
  UPDATE_DSA_AREA_NOTE_FAILURE
} = act('UPDATE_DSA_AREA_NOTE');

export const {
  ANSWER_DSA_GOAL,
  ANSWER_DSA_GOAL_SUCCESS,
  ANSWER_DSA_GOAL_FAILURE
} = act('ANSWER_DSA_GOAL');

export const {
  UPDATE_DSA_CONFIGURED_ITEM,
  UPDATE_DSA_CONFIGURED_ITEM_SUCCESS,
  UPDATE_DSA_CONFIGURED_ITEM_FAILURE
} = act('UPDATE_DSA_CONFIGURED_ITEM');

export const {
  CREATE_DSA_CUSTOM_CONFIGURED_ITEM,
  CREATE_DSA_CUSTOM_CONFIGURED_ITEM_SUCCESS,
  CREATE_DSA_CUSTOM_CONFIGURED_ITEM_FAILURE
} = act('CREATE_DSA_CUSTOM_CONFIGURED_ITEM');

export const {
  ANSWER_DSA_USE_QUESTION,
  ANSWER_DSA_USE_QUESTION_SUCCESS,
  ANSWER_DSA_USE_QUESTION_FAILURE
} = act('ANSWER_DSA_USE_QUESTION');

export const {
  ANSWER_DSA_VALUE_REALIZED,
  ANSWER_DSA_VALUE_REALIZED_SUCCESS,
  ANSWER_DSA_VALUE_REALIZED_FAILURE
} = act('ANSWER_DSA_VALUE_REALIZED');

export const {
  UPDATE_PEAK_BUFFER,
  UPDATE_PEAK_BUFFER_SUCCESS,
  UPDATE_PEAK_BUFFER_FAILURE
} = act('UPDATE_PEAK_BUFFER');

export const {
  ANSWER_CORRELATION,
  ANSWER_CORRELATION_SUCCESS,
  ANSWER_CORRELATION_FAILURE
} = act('ANSWER_CORRELATION');

export const {
  BATCH_ANSWER_CORRELATIONS,
  BATCH_ANSWER_CORRELATIONS_SUCCESS,
  BATCH_ANSWER_CORRELATIONS_FAILURE
} = act('BATCH_ANSWER_CORRELATIONS');

export const {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE
} = act('LOGIN');

export const {
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE
} = act('UPDATE_USER');

export const {
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAILURE
} = act('GET_USER');

export const {
  FETCH_OPPORTUNITIES,
  FETCH_OPPORTUNITIES_SUCCESS,
  FETCH_OPPORTUNITIES_FAILURE
} = act('FETCH_OPPORTUNITIES');

export const {
  LINK_OPPORTUNITY,
  LINK_OPPORTUNITY_SUCCESS,
  LINK_OPPORTUNITY_FAILURE
} = act('LINK_OPPORTUNITY');

export const {
  UNLINK_OPPORTUNITY,
  UNLINK_OPPORTUNITY_SUCCESS,
  UNLINK_OPPORTUNITY_FAILURE
} = act('UNLINK_OPPORTUNITY');

export const {
  CREATE_ENGAGEMENT_ITEM,
  CREATE_ENGAGEMENT_ITEM_SUCCESS,
  CREATE_ENGAGEMENT_ITEM_FAILURE
} = act('CREATE_ENGAGEMENT_ITEM');

export const {
  DELETE_ENGAGEMENT_ITEM,
  DELETE_ENGAGEMENT_ITEM_SUCCESS,
  DELETE_ENGAGEMENT_ITEM_FAILURE
} = act('DELETE_ENGAGEMENT_ITEM');

export const {
  UPDATE_ENGAGEMENT_ITEM,
  UPDATE_ENGAGEMENT_ITEM_SUCCESS,
  UPDATE_ENGAGEMENT_ITEM_FAILURE
} = act('UPDATE_ENGAGEMENT_ITEM');

export const {
  GENERATE_PPTX,
  GENERATE_PPTX_SUCCESS,
  GENERATE_PPTX_FAILURE
} = act('GENERATE_PPTX');

export const OPEN_IMPORT_SOURCES_MODAL = 'OPEN_IMPORT_SOURCES_MODAL';
export const DISMISS_IMPORT_SOURCES_MODAL = 'DISMISS_IMPORT_SOURCES_MODAL';

export const {
  IMPORT_XLS,
  IMPORT_XLS_SUCCESS,
  IMPORT_XLS_FAILURE
} = act('IMPORT_XLS');

export const {
  IMPORT_XLS_FILES,
  IMPORT_XLS_FILES_SUCCESS,
  IMPORT_XLS_FILES_FAILURE
} = act('IMPORT_XLS_FILES');

export const {
  DOWNLOAD_XLS_TEMPLATES,
  DOWNLOAD_XLS_TEMPLATES_SUCCESS,
  DOWNLOAD_XLS_TEMPLATES_FAILURE
} = act('DOWNLOAD_XLS_TEMPLATES');

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const USER_LOGGED_OUT_SUCCESS = 'USER_LOGGED_OUT_SUCCESS';

export const UNAUTHORIZED = 'UNAUTHORIZED';

export const CHANGE_DSA_CONFIGURED_ITEM = 'CHANGE_DSA_CONFIGURED_ITEM';

export const TOGGLE_ACCOUNT_DSA_SORT = 'TOGGLE_ACCOUNT_DSA_SORT';
export const TOGGLE_ACCOUNT_DSA_TYPE_FILTER = 'TOGGLE_ACCOUNT_DSA_TYPE_FILTER';
export const TOGGLE_ACCOUNT_DSA_STATUS_FILTER = 'TOGGLE_ACCOUNT_DSA_STATUS_FILTER';

export const TOGGLE_PINNED_ACCOUNT_SORT = 'TOGGLE_PINNED_ACCOUNT_SORT';

export const BEGIN_CREATE_DSA_WORKFLOW = 'BEGIN_CREATE_DSA_WORKFLOW';
export const BEGIN_CLONE_DSA_WORKFLOW = 'BEGIN_CLONE_DSA_WORKFLOW';
export const BEGIN_CONVERT_DSA_WORKFLOW = 'BEGIN_CONVERT_DSA_WORKFLOW';
export const CONFIRM_BEGIN_CONVERT_DSA_WORKFLOW = 'CONFIRM_BEGIN_CONVERT_DSA_WORKFLOW';
export const BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW = 'BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW';
export const CONFIRM_BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW = 'CONFIRM_BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW';
export const CANCEL_CREATE_DSA_WORKFLOW = 'CANCEL_CREATE_DSA_WORKFLOW';
export const PROMPT_FOR_NEW_DSA_LINKED_OPPORTUNITIES = 'PROMPT_FOR_NEW_DSA_LINKED_OPPORTUNITIES';

export const LOCALIZE_STRINGS = 'LOCALIZE_STRINGS';
export const SET_SPLUNK_LEARNING_LINK = 'SET_SPLUNK_LEARNING_LINK';

export const SALESFORCE_SYNC_ERROR = 'SALESFORCE_SYNC_ERROR';
export const CONFIRM_SALESFORCE_SYNC_ERROR = 'CONFIRM_SALESFORCE_SYNC_ERROR';

export const DISMISS_TRAINING_SNACKBAR = 'DISMISS_TRAINING_SNACKBAR';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js